{
  "version": 1,
  "asset_id": "aa27a190-3a38-418c-8a6d-efec8c505acc",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/aa27a190-3a38-418c-8a6d-efec8c505acc/bypass-revision-resection-es-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/aa27a190-3a38-418c-8a6d-efec8c505acc/bypass-revision-resection-es-480.webp",
  "original_filename": "bypass-revision-resection-es-480.webp",
  "size": 41708,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:41:36Z"
}
